<mat-form-field appearance="outline" class="search-field">
  <mat-icon matIconPrefix class="icon-magnifying-glass">search</mat-icon>
  <ng-container *ngVar="possibleContentLanguages$ | async as contentLanguages">
    @if (showContentLanguageOption && contentLanguages?.length > 1) {
      <mat-select
        (click)="handleInputClick($event)"
        matPrefix
        class="content-language-select"
        hideSingleSelectionIndicator
        [formControl]="contentLanguageControl"
        panelWidth="56px"
        >
        @if (contentLanguageControl.value) {
          <mat-select-trigger>
            <mat-icon [svgIcon]="contentLanguageControl.value.toLowerCase()"></mat-icon>
          </mat-select-trigger>
        }
        @for (contentLanguage of contentLanguages; track contentLanguage) {
          <mat-option [value]="contentLanguage">
            <mat-icon [svgIcon]="contentLanguage.toLowerCase()"></mat-icon>
          </mat-option>
        }
      </mat-select>
    }
  </ng-container>

  <input [placeholder]="'generic.search' | translate" [formControl]="searchControl" matInput (click)="handleInputClick($event)" />

  @if (searchControl.value) {
    <button class="clear" mat-mini-fab (click)="clearSearch()" [matTooltip]="'activity_search_bar.clear_query' | translate">
      <mat-icon> close </mat-icon>
    </button>
  }
</mat-form-field>
